"use strict";

require("core-js/modules/es.array.from");

var curry2 = require("./curry2.js");

var takeAll = require("./takeAll.js");

var updateL = require("../Lazy/updateL.js");

module.exports = curry2(function update(index, value, iter) {
  if (index < 0) {
    const arr = Array.from(iter);
    return update(arr.length + index, value, arr);
  } else {
    return takeAll(updateL(index, value, iter));
  }
});